module.exports = __webpack_public_path__ + "static/media/partnership-xLarge.07f1b97f.png";